import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationPA from './locales/pa/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  pa: {
    translation: translationPA,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en', // use English if selected language translations are missing
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;